export enum StoresReducerErrors {
  STORE_NOT_FOUND = 'STORE_NOT_FOUND',
}
